import React from "react";
import { PlanData } from "./mock.data";
import styles from "./index.module.scss";
import NumberInputWithControls from "../../../Common/number-input-with-controls/number-input-with-controls.component";

interface SubscriptionsTableRowProps {
  plan: PlanData;
  index: number;
  isView: boolean;
  editedValue?: { cost: number; price: number };
  periodText?: string;
  onCostChange: (value: string | number) => void;
  onCostIncrement: () => void;
  onCostDecrement: () => void;
  onPriceChange: (value: string | number) => void;
  onPriceIncrement: () => void;
  onPriceDecrement: () => void;
}

const SubscriptionsTableRow = ({
  plan,
  index,
  isView,
  editedValue,
  periodText = "/month",
  onCostChange,
  onCostIncrement,
  onCostDecrement,
  onPriceChange,
  onPriceIncrement,
  onPriceDecrement,
}: SubscriptionsTableRowProps) => {
  const extractCurrencySymbol = (value: string): string => {
    const match = value.match(/[^\d.\s]+/);
    return match ? match[0] : "";
  };

  const getCurrencySymbol = (plan: PlanData): string => {
    return extractCurrencySymbol(plan.cost) || extractCurrencySymbol(plan.price) || "";
  };

  const currencySymbol = getCurrencySymbol(plan);
  const costValue = editedValue?.cost ?? (parseFloat(plan.cost.replace(/[^\d.]/g, "")) || 0);
  const priceValue = editedValue?.price ?? (parseFloat(plan.price.replace(/[^\d.]/g, "")) || 0);
  return (
    <div className={styles.dataRow}>
      <div className={styles.dataCell}>
        <div className={styles.planName}>{plan.name}</div>
      </div>

      <div className={styles.dataCell}>
        {isView ? (
          <div className={styles.costText}>{plan.cost}</div>
        ) : (
          <NumberInputWithControls
            id={`cost-${index}`}
            value={costValue}
            currencySymbol={currencySymbol}
            onChange={onCostChange}
            onIncrement={onCostIncrement}
            onDecrement={onCostDecrement}
            min="0"
            ariaLabel={`Cost for ${plan.name}`}
          />
        )}
      </div>

      <div className={styles.dataCell}>
        {isView ? (
          <div className={styles.priceContent}>
            <div className={styles.priceWrapper}>
              <div className={styles.priceText}>{plan.price}</div>
            </div>
            <div className={styles.monthText}>{periodText}</div>
          </div>
        ) : (
          <div className={styles.priceContent}>
            <NumberInputWithControls
              id={`price-${index}`}
              value={priceValue}
              currencySymbol={currencySymbol}
              onChange={onPriceChange}
              onIncrement={onPriceIncrement}
              onDecrement={onPriceDecrement}
              min="0"
              ariaLabel={`Price for ${plan.name}`}
            />
            <div className={styles.monthText}>{periodText}</div>
          </div>
        )}
      </div>
    </div>
  );
};

export default SubscriptionsTableRow;

